import './global.js';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Header from 'components/Header';
import Footer from 'components/Footer';
import MobileMenu from 'components/MobileMenu';
import ProfileBar from 'components/ProfileBar';
import GlobalPopup from 'components/GlobalPopup';

import MainPage from 'pages/MainPage';
import LoginPage from 'pages/LoginPage';
import ShopPage from 'pages/ShopPage';
import BlogPage from 'pages/BlogPage';
import JobListPage from 'pages/JobListPage';
import JobPage from 'pages/JobPage';
import ContactPage from 'pages/ContactPage';
import RegistrationPage from 'pages/RegistrationPage.js';
import StudentsDataManagementInfoPage from 'pages/StudentsDataManagementInfoPage.js';
import ImpresszumPage from 'pages/ImpresszumPage.js';
import ReportingSystemPage from 'pages/ReportingSystemPage.js';
import AppDownload from 'pages/AppDownload.js';
import SatisfactionMeasurementPage from 'pages/SatisfactionMesurementPage.js';
import MekiMainPage from 'pages/MekiMainPage.js';
import GyakornokMainPage from 'pages/GyakornokMainPage.js';
import FaqPage from 'pages/FaqPage.js';
import DigitalAdministrationPage from 'pages/DigitalAdministrationPage.js';
import DataManagementPage from 'pages/DataManagementPage.js';
import ShopProvider from 'providers/ShopProvider.js';
import MekiAboutPage from 'pages/MekiAboutPage.js';
import LandingPage from 'pages/LandingPage.js';
import FormPage from 'pages/FormPage.js';
import DigitalAttendancePage from 'pages/DigitalAttendancePage.js';
import StudentJobAppointmentPage from 'pages/StudentJobAppointmentPage.js';
import AppDownloadPublic from 'pages/AppDownloadPublic.js';
import DigitalAdministrationInstructorPage from 'pages/DigitalAdministrationInstructorPage.js';
import RegistrationWelcomePage from 'pages/RegistrationWelcomePage.js';
import RegistrationConfirmationPage from 'pages/RegistrationConfirmationPage.js';
import RegistrationFeedbackPage from 'pages/RegistrationFeedbackPage.js';

import AuthProvider from 'providers/AuthProvider';
import WebsiteProvider, { useWebsite } from 'providers/WebsiteProvider';
import ConfigProvider, { useConfig } from 'providers/ConfigProvider';

export default function App() {
  return (
    <Router>
      <WebsiteProvider>
        <AuthProvider>
          <ConfigProvider>
            <ShopProvider>
              <Main />
            </ShopProvider>
          </ConfigProvider>
        </AuthProvider>
      </WebsiteProvider>
    </Router>
  );
}

function Main(props) {
  const { comboData, prettyUrlMap } = useConfig();
  const { profileOpen, setProfileOpen, mobileMenuOpen, setMobileMenuOpen } = useWebsite();

  return (
    <div className='w-full'>

      <GlobalPopup />

      <ProfileBar className={'transition-[margin] will-change-[margin] duration-500 z-10 ' + (profileOpen ? 'ml-0' : '-ml-72')} />
      <MobileMenu className={'transition-[margin] will-change-[margin] duration-500 z-10 ' + (mobileMenuOpen ? 'mr-0' : '-mr-72')} />

      <div
        className={'w-full lg:w-auto px-4 min-h-dvh min-w-[100%] lg:min-w-[initial] flex flex-col overflow-hidden transition-[margin] will-change-[margin] duration-500 ' + (profileOpen ? 'ml-72 ' : '') + (mobileMenuOpen ? '-ml-72 ' : '')}
        onClick={() => {
          const mobileViewport = window.matchMedia('(max-width: 1023px)').matches;
          if (mobileViewport && profileOpen) setProfileOpen(false);
          if (mobileMenuOpen) setMobileMenuOpen(false);
        }}
      >

        <Header className='' />

        <div className='relative flex-1 rounded-3xl flex flex-col bg-white/10 overflow-hidden'>

          {comboData && <Routes>
            <Route path='/' element={<MainPage />} />
            <Route path='/bejelentkezes' element={<LoginPage />} />
            <Route path='/shop' element={<ShopPage />} />
            <Route path='/blog' element={<BlogPage />} />
            <Route path='/diakmunka' element={<JobListPage />} />
            <Route path='/kapcsolat' element={<ContactPage />} />
            <Route path='/jo-tudni' element={<FaqPage />} />
            <Route path='/regisztracio' element={<RegistrationPage />} />
            <Route path="/regisztracio-visszaigazolas" element={<RegistrationWelcomePage />} />
            <Route path="/regisztracio-megerosites" element={<RegistrationConfirmationPage />} />
            <Route path="/regisztracio-veglegesites" element={<RegistrationFeedbackPage />} />
            <Route path='/digitalis-ugyintezes' element={<DigitalAdministrationPage />} />
            <Route path='/digitalis-ugyintezes-utmutato-diakoknak' element={<DigitalAdministrationInstructorPage />} />
            <Route path='/adatvedelem' element={<DataManagementPage />} />
            <Route path='/adatkezelési-tájékoztató-diákoknak' element={<StudentsDataManagementInfoPage />} />
            <Route path='/impresszum' element={<ImpresszumPage />} />
            <Route path='/belso-visszaeles-bejelentes' element={<ReportingSystemPage />} />
            <Route path='/diak-bejelentkezett-legyapprakesz' element={<AppDownload />} />
            <Route path='/app-letoltes' element={<AppDownloadPublic />} />
            <Route path='/diak-bejelentkezett-elegedettsegmeres' element={<SatisfactionMeasurementPage />} />
            <Route path='/elegedettsegmeres' element={<SatisfactionMeasurementPage />} />
            <Route path='/meki' element={<MekiMainPage />} />
            <Route path='/mi-mekisek' element={<MekiAboutPage />} />
            <Route path='/gyakornok' element={<GyakornokMainPage />} />
            {prettyUrlMap && prettyUrlMap.jobAdvertisement.map((item) => <Route key={item} path={item} element={<JobPage />} />)}
            <Route path="/landing" element={<LandingPage />} />
            <Route path="/:prettyUrl" element={<LandingPage />} />
            <Route path="/formpage" element={<FormPage />} />
            <Route path="/digitalis-jelenleti-iv" element={<DigitalAttendancePage />} />
            <Route path="/studentJobAppointment" element={<StudentJobAppointmentPage />} />

          </Routes>}

        </div>

        <Footer className='' />

      </div>

    </div>
  );
}
